import { getP } from 'redux-polyglot'
import api from '../libs/api'

/**
 * Actions for fetching games from API
 */
export const FETCH_GAMES_REQUEST = 'GAMES/FETCH_GAMES_REQUEST'
export const FETCH_GAMES_SUCCESS = 'GAMES/FETCH_GAMES_SUCCESS'
export const FETCH_GAMES_FAILURE = 'GAMES/FETCH_GAMES_FAILURE'

const fetchGamesRequest = () => ({
  type: FETCH_GAMES_REQUEST
})

const fetchGamesSuccess = games => ({
  type: FETCH_GAMES_SUCCESS,
  payload: {
    games
  }
})

const fetchGamesFailure = error => ({
  type: FETCH_GAMES_FAILURE,
  payload: error instanceof Error ? error : new Error(error),
  error: true
})

export const loadGames = () => (dispatch, getState) => {
  dispatch(fetchGamesRequest())
  return api
    .getGames()
    .then(res => res.json())
    .then(
      response => {
        if (response.status === 200) {
          return dispatch(fetchGamesSuccess(response.apps || []))
        } else {
          return dispatch(fetchGamesFailure(response.reason))
        }
      },
      () =>
        dispatch(
          fetchGamesFailure(
            getP(getState()).t('tv_html5_games.error_retrieving_games', {
              _: 'An error occurred while retrieving the list of games'
            })
          )
        )
    )
}

/**
 * Actions related to navigation
 */
export const SET_FOCUSED_POSITION = 'GAMES/SET_FOCUSED_POSITION'

export const setFocusedPosition = position => ({
  type: SET_FOCUSED_POSITION,
  payload: {
    position
  }
})
